window.addEventListener("load", () => {
  function waitForMenuToLoad() {
    const menu = document.querySelector("#qikify-tmenu-megamenu-4");
    if (menu && menu.children.length > 0) {
      menu.querySelectorAll("li.sub.tmenu_disabled").forEach((item) => {
        item.classList.remove("tmenu_disabled");
        console.warn("Menu Item was fixed");
      });
    } else {
      setTimeout(waitForMenuToLoad, 100);
    }
  }

  // Call the polling function
  waitForMenuToLoad();
});
